import DashboardIncidentsSearchBar from './DashboardIncidentsSearchBar';

export default DashboardIncidentsSearchBar;
